import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { drawerWidth } from '../Drawer/Style';

import Copyright from '../Copyright/Copyright';
import Contador from '../Contador/Contador';


const useStyles = makeStyles(
    (theme) => (
        {
            footer: {
                backgroundColor: '#014B84',
                color: '#fff',
                textAlign: 'center',
                position: 'relative',
                marginTop: theme.spacing(0),
            },
            copy: {
                width: '50%',
                display: 'inline-block',
                verticalAlign: 'top',
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
                ['@media (max-width:650px)']: { // eslint-disable-line no-useless-computed-key
                    width: '100%',
                },
            },
            contador: {
                width: '50%',
                display: 'inline-block',
                verticalAlign: 'top',
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
                ['@media (max-width:650px)']: { // eslint-disable-line no-useless-computed-key
                    width: '100%',
                },
            },
            content: {
                flexGrow: 1,
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                marginLeft: 0,
            },
            contentShift: {
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginLeft: drawerWidth,
            },
        }
    )
);


export const Footer = (props) => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.footer, classes.content, { [classes.contentShift]: props.open ?? false })} >
            <div className={classes.copy} >
                <Copyright href="http://impa.br" >
                    IMPA - Instituto de Matemática Pura e Aplicada
                </Copyright>
            </div>
            <div className={classes.contador} >
                <Contador />
            </div>
        </Box>
    )
}

export default Footer;